import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslation from '../locales/en/translation.json';
import ptBRTranslation from '../locales/pt-BR/translation.json';

const resources = {
  en: {
    translation: enTranslation
  },
  'pt-BR': {
    translation: ptBRTranslation
  }
};

const initI18n = async () => {
  await i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources,
      fallbackLng: 'en',
      debug: process.env.NODE_ENV === 'development',
      
      interpolation: {
        escapeValue: false
      },

      detection: {
        order: ['localStorage', 'navigator', 'htmlTag'],
        caches: ['localStorage'],
        lookupLocalStorage: 'i18nextLng',
        convertDetectedLanguage: (lng: string) => {
          // Convert detected language codes to our supported ones
          if (lng.startsWith('pt')) return 'pt-BR';
          return 'en';
        }
      },

      react: {
        useSuspense: false // Disable suspense for now
      }
    });
};

// Initialize immediately
initI18n();

export default i18n;